/**
 * @generated SignedSource<<036563347eaf5a9b41263ed6bf5adf19>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LessonKind = "ARTICLE" | "AUDIO_ARTICLE" | "COMMENTARY" | "MINI_STORY" | "POV" | "VOCABULARY" | "%future added value";
export type TranscriptStatus = "FAILED" | "PENDING" | "READY" | "%future added value";
export type LessonPlayerQuery$variables = {
  id: string;
};
export type LessonPlayerQuery$data = {
  readonly me: {
    readonly learner: {
      readonly defaultCharacter: {
        readonly audience: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly node: {
    readonly answerMedians?: ReadonlyArray<{
      readonly answered: number;
      readonly asked: number;
      readonly localDay: any;
      readonly medianMs: number | null | undefined;
    }>;
    readonly answerReady?: boolean;
    readonly article?: {
      readonly fileUrl: string;
      readonly id: string;
    } | null | undefined;
    readonly cues?: ReadonlyArray<{
      readonly atMs: number;
      readonly text: string;
    }>;
    readonly durationMs?: number | null | undefined;
    readonly fileUrl?: string;
    readonly id?: string;
    readonly kind?: LessonKind;
    readonly lines?: ReadonlyArray<{
      readonly endMs: number;
      readonly startMs: number;
      readonly text: string;
    }>;
    readonly part?: string | null | undefined;
    readonly transcriptStatus?: TranscriptStatus | null | undefined;
  } | null | undefined;
};
export type LessonPlayerQuery = {
  response: LessonPlayerQuery$data;
  variables: LessonPlayerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "audience",
  "storageKey": null
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "part",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationMs",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileUrl",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transcriptStatus",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answerReady",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "LessonCue",
  "kind": "LinkedField",
  "name": "cues",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "atMs",
      "storageKey": null
    },
    (v10/*:: as any*/)
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "LessonDayMedian",
  "kind": "LinkedField",
  "name": "answerMedians",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localDay",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "medianMs",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "answered",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "asked",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "LessonLine",
  "kind": "LinkedField",
  "name": "lines",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startMs",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endMs",
      "storageKey": null
    },
    (v10/*:: as any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "Lesson",
  "kind": "LinkedField",
  "name": "article",
  "plural": false,
  "selections": [
    (v3/*:: as any*/),
    (v7/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LessonPlayerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*:: as any*/),
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v11/*:: as any*/),
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              (v14/*:: as any*/)
            ],
            "type": "Lesson",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "LessonPlayerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Learner",
            "kind": "LinkedField",
            "name": "learner",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Character",
                "kind": "LinkedField",
                "name": "defaultCharacter",
                "plural": false,
                "selections": [
                  (v1/*:: as any*/),
                  (v3/*:: as any*/)
                ],
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v3/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              (v7/*:: as any*/),
              (v8/*:: as any*/),
              (v9/*:: as any*/),
              (v11/*:: as any*/),
              (v12/*:: as any*/),
              (v13/*:: as any*/),
              (v14/*:: as any*/)
            ],
            "type": "Lesson",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1f9bfcba3f073bc99ffd6915b4ac5574",
    "id": null,
    "metadata": {},
    "name": "LessonPlayerQuery",
    "operationKind": "query",
    "text": "query LessonPlayerQuery(\n  $id: ID!\n) {\n  me {\n    learner {\n      defaultCharacter {\n        audience\n        id\n      }\n      id\n    }\n  }\n  node(id: $id) {\n    __typename\n    ... on Lesson {\n      id\n      kind\n      part\n      durationMs\n      fileUrl\n      transcriptStatus\n      answerReady\n      cues {\n        atMs\n        text\n      }\n      answerMedians {\n        localDay\n        medianMs\n        answered\n        asked\n      }\n      lines {\n        startMs\n        endMs\n        text\n      }\n      article {\n        id\n        fileUrl\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "50d5e82726337fd4c1cea3403b6b73c7";

export default node;
